export type TcruziFastqRole =
  | "cell_barcode, umi_barcode"
  | "single"
  | "sample_barcode";

export type TcruziFastqFile = {
  name: string;
  readType: TcruziFastqRole;
  readIndex: "read1" | "read2" | "index1" | "index2";
  url: string;
};

export type TcruziRun = {
  accession: string;
  assay: string;
  dualIndex?: boolean;
};

export type TcruziSample = {
  id: string;
  sourceName: string;
  enaSample: string;
  bioSample: string;
  cellType: string;
  cellTypeZh: string;
  experiment: string;
  technicalReplicateGroup: string | null;
  scope: "atlas" | "validation";
  runs: TcruziRun[];
};

export const tcruziRunManifest = {
  schemaVersion: "1.0.0",
  accession: "E-MTAB-14406",
  enaStudy: "ERP163729",
  retrieved: "2026-07-26",
  source: {
    sdrfUrl:
      "https://ftp.ebi.ac.uk/biostudies/fire/E-MTAB-/406/E-MTAB-14406/Files/E-MTAB-14406.sdrf.txt",
    sdrfSha256:
      "f95f4d5470f2208d24db827147bf3302a61c453cbc208301023d078af12a8c54",
    biostudiesUrl:
      "https://www.ebi.ac.uk/biostudies/arrayexpress/studies/E-MTAB-14406",
    enaStudyUrl: "https://www.ebi.ac.uk/ena/browser/view/ERP163729",
  },
  library: {
    construction: "10x 3′ v3",
    layout: "PAIRED",
    selection: "Oligo-dT",
    source: "TRANSCRIPTOMIC SINGLE CELL",
    strategy: "RNA-Seq",
    cdnaRead: "read2",
    cdnaReadSize: 91,
    cellBarcodeRead: "read1",
    cellBarcodeSize: 16,
    umiBarcodeRead: "read1",
    umiBarcodeSize: 12,
    sampleBarcodeRead: "index1",
    sampleBarcodeSize: 8,
  },
  samples: [
    {
      id: "sample-1",
      sourceName: "Sample 1 (cycle_epimast)",
      enaSample: "ERS20928730",
      bioSample: "SAMEA115968800",
      cellType: "Epimastigote and 120 hpi amastigotes",
      cellTypeZh: "上鞭毛体和感染后 120 小时无鞭毛体",
      experiment: "ERX12989002",
      technicalReplicateGroup: "group 1",
      scope: "atlas",
      runs: [
        {
          accession: "ERR13618077",
          assay: "Cycle_epimast_a_AK938_HYV3LDSX3_S5_L001",
        },
        {
          accession: "ERR13618068",
          assay: "Cycle_epimast_b_AK939_HYV3LDSX3_S6_L001",
        },
        {
          accession: "ERR13618067",
          assay: "Cycle_epimast_d_AK941_HYV3LDSX3_S8_L001",
        },
        {
          accession: "ERR13618071",
          assay: "Cycle_epimast_c_AK940_HYV3LDSX3_S7_L001",
        },
      ],
    },
    {
      id: "sample-2",
      sourceName: "Sample 2 (cycle_amast)",
      enaSample: "ERS20928731",
      bioSample: "SAMEA115968801",
      cellType: "6 and 24 hpi amastigotes",
      cellTypeZh: "感染后 6 和 24 小时无鞭毛体",
      experiment: "ERX12989003",
      technicalReplicateGroup: "group 2",
      scope: "atlas",
      runs: [
        {
          accession: "ERR13618072",
          assay: "Cycle_amast_a_AK646_HYV3LDSX3_S1_L001",
        },
        {
          accession: "ERR13618066",
          assay: "Cycle_amast_d_AK649_HYV3LDSX3_S4_L001",
        },
        {
          accession: "ERR13618074",
          assay: "Cycle_amast_c_AK648_HYV3LDSX3_S3_L001",
        },
        {
          accession: "ERR13618063",
          assay: "Cycle_amast_b_AK647_HYV3LDSX3_S2_L001",
        },
      ],
    },
    {
      id: "sample-3",
      sourceName: "Sample 3 (cycle_metacyc1)",
      enaSample: "ERS20928732",
      bioSample: "SAMEA115968802",
      cellType: "metacyclic trypomastigotes",
      cellTypeZh: "后循环型锥鞭毛体",
      experiment: "ERX12989004",
      technicalReplicateGroup: "group 3",
      scope: "atlas",
      runs: [
        {
          accession: "ERR13618069",
          assay: "Cycle_metacyc1_b_AK947_HYV3LDSX3_S14_L001",
        },
        {
          accession: "ERR13618062",
          assay: "Cycle_metacyc1_a_AK946_HYV3LDSX3_S13_L001",
        },
        {
          accession: "ERR13618076",
          assay: "Cycle_metacyc1_d_AK949_HYV3LDSX3_S16_L001",
        },
        {
          accession: "ERR13618064",
          assay: "Cycle_metacyc1_c_AK948_HYV3LDSX3_S15_L001",
        },
      ],
    },
    {
      id: "sample-4",
      sourceName: "Sample 4 (cycle_metacyc2)",
      enaSample: "ERS20928733",
      bioSample: "SAMEA115968803",
      cellType: "metacyclic trypomastigotes",
      cellTypeZh: "后循环型锥鞭毛体",
      experiment: "ERX12989005",
      technicalReplicateGroup: "group 4",
      scope: "atlas",
      runs: [
        {
          accession: "ERR13618078",
          assay: "Cycle_metacyc2_b_AK931_HYV3LDSX3_S18_L001",
        },
        {
          accession: "ERR13618059",
          assay: "Cycle_metacyc2_d_AK933_HYV3LDSX3_S20_L001",
        },
        {
          accession: "ERR13618060",
          assay: "Cycle_metacyc2_c_AK932_HYV3LDSX3_S19_L001",
        },
        {
          accession: "ERR13618079",
          assay: "Cycle_metacyc2_a_AK930_HYV3LDSX3_S17_L001",
        },
      ],
    },
    {
      id: "sample-5",
      sourceName: "Sample 5 (cycle_trypomast)",
      enaSample: "ERS20928734",
      bioSample: "SAMEA115968804",
      cellType: "trypomastigotes",
      cellTypeZh: "锥鞭毛体",
      experiment: "ERX12989006",
      technicalReplicateGroup: "group 5",
      scope: "atlas",
      runs: [
        {
          accession: "ERR13618080",
          assay: "Cycle_trypomast_b_AK943_HYV3LDSX3_S10_L001",
        },
        {
          accession: "ERR13618061",
          assay: "Cycle_trypomast_d_AK945_HYV3LDSX3_S12_L001",
        },
        {
          accession: "ERR13618073",
          assay: "Cycle_trypomast_c_AK944_HYV3LDSX3_S11_L001",
        },
        {
          accession: "ERR13618075",
          assay: "Cycle_trypomast_a_AK942_HYV3LDSX3_S9_L001",
        },
      ],
    },
    {
      id: "sample-6",
      sourceName: "Sample 6 (LifeCycleMix1)",
      enaSample: "ERS20928735",
      bioSample: "SAMEA115968805",
      cellType:
        "metacyclic trypomastigotes, 6, 24 and 120 hpi amastigotes, trypomastigotes and epimastigotes",
      cellTypeZh:
        "后循环型锥鞭毛体、感染后 6/24/120 小时无鞭毛体、锥鞭毛体和上鞭毛体",
      experiment: "ERX12989007",
      technicalReplicateGroup: "group 6",
      scope: "atlas",
      runs: [
        {
          accession: "ERR13618081",
          assay: "LifeCycleMix1_SCI7T012_SCI5T012_HF552DSX7_S1_L001",
          dualIndex: true,
        },
        {
          accession: "ERR13618065",
          assay: "LifeCycleMix1_SCI7T012_SCI5T012_HF552DSX7_S1_L002",
          dualIndex: true,
        },
      ],
    },
    {
      id: "sample-7",
      sourceName: "Sample 7 (LifeCycleMix2)",
      enaSample: "ERS20928736",
      bioSample: "SAMEA115968806",
      cellType:
        "metacyclic trypomastigotes, 6, 24 and 120 hpi amastigotes, trypomastigotes and epimastigotes",
      cellTypeZh:
        "后循环型锥鞭毛体、感染后 6/24/120 小时无鞭毛体、锥鞭毛体和上鞭毛体",
      experiment: "ERX12989008",
      technicalReplicateGroup: "group 7",
      scope: "atlas",
      runs: [
        {
          accession: "ERR13618082",
          assay: "LifeCycleMix2_SCI7T024_SCI5T024_HF552DSX7_S2_L002",
          dualIndex: true,
        },
        {
          accession: "ERR13618070",
          assay: "LifeCycleMix2_SCI7T024_SCI5T024_HF552DSX7_S2_L001",
          dualIndex: true,
        },
      ],
    },
    {
      id: "sample-8",
      sourceName: "Sample 8 (amast_48)",
      enaSample: "ERS22930289",
      bioSample: "SAMEA117601648",
      cellType: "48 hpi amastigotes",
      cellTypeZh: "感染后 48 小时无鞭毛体",
      experiment: "ERX13553051",
      technicalReplicateGroup: null,
      scope: "validation",
      runs: [
        {
          accession: "ERR14150393",
          assay: "A2_AK2003_HNLWVDSX2_S1_L001",
        },
      ],
    },
  ] satisfies TcruziSample[],
};

const fileRoles = [
  {
    suffix: "R1",
    readType: "cell_barcode, umi_barcode",
    readIndex: "read1",
  },
  { suffix: "R2", readType: "single", readIndex: "read2" },
  { suffix: "I1", readType: "sample_barcode", readIndex: "index1" },
] as const;

export function getTcruziRunFiles(run: TcruziRun): TcruziFastqFile[] {
  const roles = run.dualIndex
    ? [
        ...fileRoles,
        {
          suffix: "I2",
          readType: "sample_barcode" as const,
          readIndex: "index2" as const,
        },
      ]
    : fileRoles;
  const volume = run.accession.slice(0, 6);

  return roles.map((role) => {
    const name = `${run.assay}_${role.suffix}_001.fastq.gz`;
    return {
      name,
      readType: role.readType,
      readIndex: role.readIndex,
      url: `https://ftp.sra.ebi.ac.uk/vol1/run/${volume}/${run.accession}/${name}`,
    };
  });
}

export function getExpandedTcruziRunManifest() {
  return {
    ...tcruziRunManifest,
    totals: {
      sourceSamples: tcruziRunManifest.samples.length,
      experiments: new Set(
        tcruziRunManifest.samples.map((sample) => sample.experiment),
      ).size,
      runs: tcruziRunManifest.samples.reduce(
        (sum, sample) => sum + sample.runs.length,
        0,
      ),
      fastqEntries: tcruziRunManifest.samples.reduce(
        (sum, sample) =>
          sum +
          sample.runs.reduce(
            (runSum, run) => runSum + getTcruziRunFiles(run).length,
            0,
          ),
        0,
      ),
    },
    samples: tcruziRunManifest.samples.map((sample) => ({
      ...sample,
      runs: sample.runs.map((run) => ({
        ...run,
        enaUrl: `https://www.ebi.ac.uk/ena/browser/view/${run.accession}`,
        files: getTcruziRunFiles(run),
      })),
    })),
  };
}
